export const AppSettings = {
  sitePermissions: [
    /** t(permissions.clientsRead) */
    { value: 'clients', name: 'permissions.clientsRead' },
    /** t(permissions.clientsEdit) */
    { value: 'clients_edit', name: 'permissions.clientsEdit' },
    /** t(permissions.executionsRead) */
    { value: 'executions', name: 'permissions.executionsRead' },
    /** t(permissions.executionsEdit) */
    { value: 'executions_edit', name: 'permissions.executionsEdit' },
    /** t(permissions.kohodocumentsEdit) */
    { value: 'kohodocuments_edit', name: 'permissions.kohodocumentsEdit' },
    /** t(permissions.kohoprices) */
    { value: 'kohoprices', name: 'permissions.kohoprices' },
    /** t(permissions.queues) */
    { value: 'queues', name: 'permissions.queues' },
    /** t(permissions.systems) */
    { value: 'systems', name: 'permissions.systems' },
    /** t(permissions.settingsRead) */
    { value: 'settings', name: 'permissions.settingsRead' },
    /** t(permissions.settingsEdit) */
    { value: 'settings_edit', name: 'permissions.settingsEdit' },
    /** t(permissions.processModelsRead) */
    { value: 'process-models', name: 'permissions.processModelsRead' },
    /** t(permissions.processModelsEdit) */
    { value: 'process-models_edit', name: 'permissions.processModelsEdit' },
    /** t(permissions.kohosearchUnlimited) */
    { value: 'kohosearch_unlimited', name: 'permissions.kohosearchUnlimited' },
    /** t(permissions.resourceLocks) */
    { value: 'resource-locks', name: 'permissions.resourceLocks' },
    /** t(permissions.secretsRead) */
    { value: 'secrets', name: 'permissions.secretsRead' },
    /** t(permissions.secretsEdit) */
    { value: 'secrets_edit', name: 'permissions.secretsEdit' },
    /** t(permissions.signAdmin) */
    { value: 'sign_admin', name: 'permissions.signAdmin' },
    /** t(permissions.signSkipInvoicing) */
    { value: 'sign_skip_invoicing', name: 'permissions.signSkipInvoicing' },
    /** t(permissions.emails) */
    { value: 'emails', name: 'permissions.emails' },
    /** t(permissions.smsMessages) */
    { value: 'sms-messages', name: 'permissions.smsMessages' },
    /** t(permissions.announcements) */
    { value: 'announcements', name: 'permissions.announcements' },
    /** t(permissions.executionsErrors) */
    { value: 'executions-errors', name: 'permissions.executionsErrors' },
    /** t(permissions.pulseRemoved) */
    { value: 'pulse', name: 'permissions.pulseRemoved' },
    /** t(permissions.pulseAdmin) */
    { value: 'pulse_admin', name: 'permissions.pulseAdmin' },
    /** t(permissions.teamsMessagesRead) */
    { value: 'teamsmessages', name: 'permissions.teamsMessagesRead' },
    /** t(permissions.teamsMessagesEdit) */
    { value: 'teamsmessages_edit', name: 'permissions.teamsMessagesEdit' },
    // Temporary group to see the entry templates block for Pulse users
    // We want to limit testers at the early stage, because the feature is quite complex and requires real world testing
    /** t(permissions.pulseEntryTemplateTemporary) */
    { value: 'pulse_entry_template_temporary', name: 'permissions.pulseEntryTemplateTemporary' },
    /** t(permissions.priceIncrease2021) */
    { value: 'hinnankorotus2021', name: 'permissions.priceIncrease2021' },
  ],

  clientTypes: [
    /** t(clients.type.azureFunction) */
    { value: 'Azure Function', name: 'clients.type.azureFunction' },
    /** t(clients.type.postman) */
    { value: 'Postman', name: 'clients.type.postman' },
    /** t(clients.type.uiPath) */
    { value: 'UIPath', name: 'clients.type.uiPath' },
    /** t(clients.type.onPremiseInmics) */
    { value: 'OnPremise (Inmics)', name: 'clients.type.onPremiseInmics' },
    /** t(clients.type.mostDigital) */
    { value: 'Most', name: 'clients.type.mostDigital' },
    /** t(clients.type.other) */
    { value: 'Other', name: 'clients.type.other' },
    /** t(clients.type.rancldfs01) */
    { value: 'RANCLDFS01', name: 'clients.type.rancldfs01' },
    /** t(clients.type.ranclddc02) */
    { value: 'RANCLDDC02', name: 'clients.type.ranclddc02' },
  ],

  secretTypes: [
    /** t(secrets.type.apiKey) */
    { value: 'api_key', name: 'secrets.type.apiKey' },
    /** t(secrets.type.connectionString) */
    { value: 'connection_string', name: 'secrets.type.connectionString' },
    /** t(secrets.type.password) */
    { value: 'password', name: 'secrets.type.password' },
  ],

  secretTargets: [
    /** t(secrets.target.internal) */
    { value: 'internal', name: 'secrets.target.internal' },
    /** t(secrets.target.customer) */
    { value: 'customer', name: 'secrets.target.customer' },
  ],

  clientLanguages: [
    /** t(clients.language.typeScript) */
    { value: 'TypeScript', name: 'clients.language.typeScript' },
    /** t(clients.language.javascript) */
    { value: 'Javascript', name: 'clients.language.javascript' },
    /** t(clients.language.postman) */
    { value: 'Postman', name: 'clients.language.postman' },
    /** t(clients.language.powerShell) */
    { value: 'PowerShell', name: 'clients.language.powerShell' },
    /** t(clients.language.uiPath) */
    { value: 'UIPath', name: 'clients.language.uiPath' },
    /** t(clients.language.python) */
    { value: 'Python', name: 'clients.language.python' },
  ],

  /** allowedPages do not require specific sitePermission */
  allowedPages: ['kohosearch', 'kohodocuments', 'triggers', 'tasks', 'sign', 'user', 'requests', 'pulse', 'memos'],
};
